import { useEffect, useRef, useState } from "react";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../assets/toastUtils";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Header/Header";
import NewSearchSateInput from "../../../NewSearchSateInput/NewSearchSateInput";
import Flatpickr from "react-flatpickr";
import styles from "./NewUiSearchFormTransport.module.scss";
import { calculateToDatePlus } from "../../../../utils/utils";
import TransportHubsSearchInput from "../../../NewSearchSateInput/TransportHubsSearchInput";
import MultiSelectSearch from "../../../NewSearchSateInput/MultiSelectSearch";
import { SvgRightIcon, SvgSearch } from "../../../../utils/svgIcons";
import TransportHomepageHubsSearchInput from "../../../NewSearchSateInput/TransportHomepageHubsSearchInput";
import NewMultiSelectSearch from "../../../NewSearchSateInput/NewMultiSelectSearch";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

function NewUiSearchFormTransport({ topRadios }) {
  const [guestDetails, setIsguestDetails] = useState(false);
  const [hub, setHub] = useState("");
  const [show, setShow] = useState(false);

  const [destinationToggle, setdestinationToggle] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  const [startDestination, setStartDestination] = useState("");
  const [endDestination, setEndDestination] = useState("");
  const [noOfDays, setNoOfDays] = useState("");

  const [selectedType, setSelectedType] = useState(null);
  // const [stateResultArray, setStateResultArray] = useState("");
  // console.log(stateResultArray);

  const getDataFromChild = (data, resultArray) => {
    setHub(data);
    // setSelectedType(selectedType);
    // setStateResultArray(resultArray)
  };

  const getDataFromChildForToCity = (data, resultArray, selectedType) => {
    setEndDestination(data);
    setSelectedType(selectedType);
    // setStateResultArray(resultArray)
  };
  // console.log(dataFromChild, "getDataFromChild");

  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const checkinDay = queryParams.get("checkinDay") || "";
  const checkinMonth = queryParams.get("checkinMonth") || "";
  const checkinYear = queryParams.get("checkinYear") || "";
  const checkoutDay = queryParams.get("checkoutDay") || "";
  const checkoutMonth = queryParams.get("checkoutMonth") || "";
  const checkoutYear = queryParams.get("checkoutYear") || "";

  const [checkin, setCheckin] = useState({
    day: checkinDay,
    month: checkinMonth,
    year: checkinYear,
  });

  const [checkout, setCheckout] = useState({
    day: checkoutDay,
    month: checkoutMonth,
    year: checkoutYear,
  });

  const navigate = useNavigate();

  // STATES
  // const [date, setDate] = useState(new Date());
  const [date, setDate] = useState(() => {
    const today = new Date();
    today.setDate(today.getDate() + 7);
    return today;
  });

  const [selectedRadio, setSelectedRadio] = useState("");

  const [data, setData] = useState({
    fromCity: "",
    toCity: "",
  });

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  //
  const [adult, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);

  // Date alterations
  const [loader, setLoader] = useState(false);

  // const [checkin, setCheckin] = useState({
  //   day: router.query.checkinDay || "",
  //   month: router.query.checkinMonth || "",
  //   year: router.query.checkinYear || "",
  // });

  // const [checkout, setCheckout] = useState({
  //   day: router.query.checkoutDay || "",
  //   month: router.query.checkoutMonth || "",
  //   year: router.query.checkoutYear || "",
  // });

  useEffect(() => {
    if (
      checkinDay &&
      checkinMonth &&
      checkinYear &&
      checkoutDay &&
      checkoutMonth &&
      checkoutYear
    ) {
      const formatDateToString = (year, month, day) => {
        const paddedMonth = String(month).padStart(2, "0");
        const paddedDay = String(day).padStart(2, "0");
        return `${year}-${paddedMonth}-${paddedDay}`;
      };

      const checkInDateString = formatDateToString(
        checkinYear,
        checkinMonth,
        checkinDay
      );
      const checkOutDateString = formatDateToString(
        checkoutYear,
        checkoutMonth,
        checkoutDay
      );

      const checkInDate = new Date(checkInDateString);
      const checkOutDate = new Date(checkOutDateString);

      setStartDate(checkInDate);
      setEndDate(checkOutDate);
    }
  }, [
    checkinDay,
    checkinMonth,
    checkinYear,
    checkoutDay,
    checkoutMonth,
    checkoutYear,
  ]);

  // functions for increase decrease
  const onChildDecrease = (e) => {
    e.preventDefault();
    const updatedChildren = children - 1;
    setChildren(updatedChildren);
    const updatedAges = childAge.slice(0, childAge.length - 1);
    setChildAge(updatedAges);
  };

  const onChildIncrease = (e) => {
    e.preventDefault();
    const updatedChildren = children + 1;
    setChildren(updatedChildren);
    setChildAge([...childAge, ""]);
  };

  const onAdultIncrease = () => {
    const newAdult = adult + 1;
    setAdults(newAdult);
    if (newAdult > 1 && newAdult % 2 === 0 && rooms < newAdult / 2) {
      setRooms(rooms + 1);
    }
  };

  const onAdultDecrease = () => {
    if (adult > 1) {
      const newAdult = adult - 1;
      setAdults(newAdult);
      if (newAdult % 2 !== 0 && rooms > 1) {
        setRooms(rooms - 1);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
  };

  const handleChildrenAgeChange = (index, event) => {
    const updatedAges = [...childAge];
    const ageValue = event.target.value.replace(/[^0-9]/g, "");

    if (ageValue > 12) {
      showErrorToast("Age should be less than or equal to 12");
      return;
    }

    updatedAges[index] = ageValue !== "" ? parseInt(ageValue, 10) : "";
    setChildAge(updatedAges);
  };

  const [selectedMultipleDestinations, setSelectedMultipleDestinations] =
    useState([]);

  const handleMultiDestinationsChange = (selected) => {
    setSelectedMultipleDestinations(selected);
  };

  const handleSubmitButtonClickHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    if (selectedMultipleDestinations.length === 0) {
      showErrorToast("Please select destinations!");
      return;
    }

    setLoader(true);

    try {
      await navigate(
        `/transport/listing?startdestination=${hub}&noOfDays=${noOfDays}&date=${new Date(
          date
        ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
          date
        ).getFullYear()}&selectedDestination=${selectedMultipleDestinations?.length
        }`,
        {
          state: {
            includingDestinations: selectedMultipleDestinations,
          },
        },
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitButtonClickHandlerTransport = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setLoader(true);

    try {
      await navigate(
        `/transport/${selectedType?.packagehandle}?packageId=${selectedType?.id
        }&startdestination=${hub}&noOfDays=${noOfDays}&date=${new Date(
          date
        ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
          date
        ).getFullYear()}`,
        {
          state: {
            includingDestinations: selectedMultipleDestinations,
          },
        },
        undefined,
        { shallow: false }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (destinationToggle) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [destinationToggle]);
  return (
    <div>
      {width <= 640 && (
        <div className={styles.NewUiSearchWrapperMobile}>
          <div
            className={styles.NewUiSearchParentMobile}
            onClick={() => {
              setShow((prev) => !prev);
              setIsguestDetails(false);
              setdestinationToggle(false);
            }}
          >
            <div>
              <SvgSearch />
            </div>

            <div>Where would you like to go ?</div>

            <div>
              <SvgRightIcon />
            </div>
          </div>

          {show && (
            <form
              className={styles.NewUiSearchWrapperFormMobile}
              onSubmit={
                selectedType?.type === "package"
                  ? handleSubmitButtonClickHandlerTransport
                  : handleSubmitButtonClickHandler
              }
            >
              <div className="">
                <label htmlFor="">STARTING FROM</label>
                <TransportHubsSearchInput
                  onClick={() => setdestinationToggle(true)}
                  onDataChange={getDataFromChild}
                  dropdownGuestDetails={dropdownGuestDetails}
                  setIsguestDetails={setIsguestDetails}
                />

                {/* <PackagesStateInput onDataChange={getDataFromChild} /> */}
                {/* 
                                             <NewSearchSateInput
                                                 onClick={() => setdestinationToggle(true)}
                                                 onDataChange={getDataFromChild}
                                                 dropdownGuestDetails={dropdownGuestDetails}
                                                 setIsguestDetails={setIsguestDetails}
                                                 type="destination"
                                                 package_type="transport"
                                             /> */}
              </div>
              <div className={styles.leftLineBorder}>
                <label htmlFor="">Including Destinations</label>
                {/* <MultiSelectSearch
                  onClick={() => setdestinationToggle(true)}
                  onMultiSelectionChange={handleMultiDestinationsChange}
                  // selectedMultipleDestinations={selectedMultipleDestinations}
                  defaultSelected={selectedMultipleDestinations}
                  className={"search_form_input"}
                /> */}


                <NewMultiSelectSearch
                  onClick={() => setdestinationToggle(true)}
                  onMultiSelectionChange={handleMultiDestinationsChange}
                  // selectedMultipleDestinations={selectedMultipleDestinations}
                  defaultSelected={selectedMultipleDestinations}
                  className={"search_form_input"}
                />
              </div>
              <div
                className={`${styles.leftLineBorder} ${styles.widthOfNoOfDays}`}
              >
                <label htmlFor="">No. of Days</label>
                <input
                  type="number"
                  placeholder="1"
                  value={noOfDays}
                  onChange={(e) => setNoOfDays(e.target.value)}
                  style={{
                    border: "none",
                    outline: "none",
                    margin: "0",
                    width: "100%",
                  }}
                  required
                />
              </div>
              <div className={`${styles.leftLineBorder} new_date_picker_react_js_custom_styling`}>
                <label>Departure Date </label>
                {/* <Flatpickr
                  className="m_0 serach_form_input"
                  color="#ffffff"
                  value={date}
                  onChange={([date]) => setDate(date)}
                  min={new Date()}
                  // f
                  options={{
                    minDate: "today",
                  }}
                /> */}

                <div className={styles.new_date_picker_wrapper}>
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    portalId="root-portal NewUIReactDatePicker"
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                    dateFormat="dd MMM, yyyy"
                    placeholderText={date ? format(date, "dd MMM, yyyy") : "Travel Date"}
                  />
                </div>
              </div>

              <button type="submit" className={styles.submitButton}>
                Search
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <mask
                      id="mask0_6818_5962"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="18"
                      height="18"
                    >
                      <rect width="18" height="18" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6818_5962)">
                      <path
                        d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                </span>
              </button>
            </form>
          )}
        </div>
      )}

      <section
        onClick={() => setShow(false)}
        className={styles.NewUiSearchWrapper}
        id="home"
      >
        <div className={styles.NewUiSearchParent}>
          <h1 className="text-center">Find Transport For Himachal</h1>
          <div
            className=""
            style={
              guestDetails || destinationToggle
                ? { zIndex: "999" }
                : { position: "" }
            }
          >
            {width > 640 && (
              <form
                className={styles.NewUiSearchFormWrapper}
                onSubmit={
                  selectedType?.type === "package"
                    ? handleSubmitButtonClickHandlerTransport
                    : handleSubmitButtonClickHandler
                }
              >
                <div className={styles.widthOfDestination}>
                  <label htmlFor="">STARTING FROM</label>
                  <TransportHomepageHubsSearchInput
                    onClick={() => setdestinationToggle(true)}
                    onDataChange={getDataFromChild}
                    dropdownGuestDetails={dropdownGuestDetails}
                    setIsguestDetails={setIsguestDetails}
                  />

                  {/* <PackagesStateInput onDataChange={getDataFromChild} /> */}
                  {/* 
                                            <NewSearchSateInput
                                                onClick={() => setdestinationToggle(true)}
                                                onDataChange={getDataFromChild}
                                                dropdownGuestDetails={dropdownGuestDetails}
                                                setIsguestDetails={setIsguestDetails}
                                                type="destination"
                                                package_type="transport"
                                            /> */}
                </div>
                <div className={styles.leftLineBorder}>
                  <label htmlFor="">Including Destinations</label>
                  <NewMultiSelectSearch
                    onClick={() => setdestinationToggle(true)}
                    onMultiSelectionChange={handleMultiDestinationsChange}
                    // selectedMultipleDestinations={selectedMultipleDestinations}
                    defaultSelected={selectedMultipleDestinations}
                    className={"search_form_input"}
                  />
                </div>
                <div className={`${styles.widthOfNoOfDays}`}>
                  <label htmlFor="">No. of Days</label>
                  <input
                    type="number"
                    placeholder="1"
                    value={noOfDays}
                    onChange={(e) => setNoOfDays(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      margin: "0",
                      width: "100%",
                    }}
                    required
                  />
                </div>
                <div className={`${styles.leftLineBorder} new_date_picker_react_js_custom_styling`}>
                  <label>Departure Date</label>
                  {/* <Flatpickr
                    className="m_0 serach_form_input"
                    color="#ffffff"
                    value={date}
                    onChange={([date]) => setDate(date)}
                    min={new Date()}
                    // f
                    options={{
                      minDate: "today",
                    }}
                  /> */}

                  <div className={styles.new_date_picker_wrapper}>
                    <DatePicker
                      selected={date}
                      onChange={(date) => setDate(date)}
                      portalId="root-portal NewUIReactDatePicker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      dateFormat="dd MMM, yyyy"
                      placeholderText={date ? format(date, "dd MMM, yyyy") : "Travel Date"}
                    />
                  </div>
                </div>
                <div className={styles.submitButtonDiv}>
                  <button type="submit" className={styles.submitButton}>
                    Search
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <mask
                          id="mask0_6818_5962"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="18"
                        >
                          <rect width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_6818_5962)">
                          <path
                            d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                            fill="white"
                          />
                        </g>
                      </svg>
                    </span>
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* {width <= 640 && (
        <form
          className={styles.NewUiSearchFormWrapper}
          onSubmit={
            selectedType?.type === "package"
              ? handleSubmitButtonClickHandlerTransport
              : handleSubmitButtonClickHandler
          }
        >
          <div className="">
            <label htmlFor="">STARTING FROM</label>
            <TransportHubsSearchInput
              onClick={() => setdestinationToggle(true)}
              onDataChange={getDataFromChild}
              dropdownGuestDetails={dropdownGuestDetails}
              setIsguestDetails={setIsguestDetails}
            />
          </div>
          <div className={styles.leftLineBorder}>
            <label htmlFor="">Including Destinations</label>
            <MultiSelectSearch
              onClick={() => setdestinationToggle(true)}
              onMultiSelectionChange={handleMultiDestinationsChange}
              // selectedMultipleDestinations={selectedMultipleDestinations}
              defaultSelected={selectedMultipleDestinations}
              className={"search_form_input"}
            />
          </div>
          <div className={`${styles.leftLineBorder} ${styles.widthOfNoOfDays}`}>
            <label htmlFor="">No. of Days</label>
            <input
              type="number"
              placeholder="1"
              value={noOfDays}
              onChange={(e) => setNoOfDays(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                margin: "0",
                width: "100%",
              }}
              required
            />
          </div>
          <div className={styles.leftLineBorder}>
            <label>Departure Date</label>
            <Flatpickr
              className="m_0 serach_form_input"
              color="#ffffff"
              value={date}
              onChange={([date]) => setDate(date)}
              min={new Date()}
              // f
              options={{
                minDate: "today",
              }}
            />
          </div>
          <div className="">
            <button type="submit" className={styles.submitButton}>
              SEARCH
              <span>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="12"
                  viewBox="0 0 17 12"
                  fill="none"
                >
                  <g clipPath="url(#clip0_6093_5578)">
                    <path
                      d="M16.5488 5.27416C12.5086 4.76301 11.0605 0.540892 11.0395 0.5L10.0426 0.816914C10.0951 0.980483 11.1235 3.97584 13.9253 5.48885H0V6.51115H13.9253C11.134 8.02416 10.0951 11.0297 10.0426 11.1831L11.0395 11.5C11.0395 11.5 12.5086 7.23699 16.5488 6.72584L17.0105 6.6645V5.32528L16.5488 5.26394V5.27416Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6093_5578">
                      <rect
                        width="17"
                        height="11"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </button>
          </div>
        </form>
      )} */}

      {(guestDetails || destinationToggle) && (
        <div
          onClick={() => [
            setIsguestDetails(false),
            setdestinationToggle(false),
          ]}
          className="ScreenDimmer"
        ></div>
      )}
    </div>
  );
}

export default NewUiSearchFormTransport;
